import { OP, STATUS } from "../../constant";

const INITIAL_STATE = {
  // -------- tarrif initial ------- //
  listTarrifStatus: STATUS.DEFAULT,
  listTarrifResult: null,
  listTarrifErrorMessage: "",

  createTarrifStatus: STATUS.DEFAULT,
  createTarrifResult: null,
  createTarrifErrorMessage: "",

  updateTarrifStatus: STATUS.DEFAULT,
  updateTarrifResult: null,
  updateTarrifErrorMessage: "",

  deleteTarrifStatus: STATUS.DEFAULT,
  deleteTarrifResult: null,
  deleteTarrifErrorMessage: "",
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    // *-------- > list tarrif reducers
    case OP.LIST_TARRIF_LOADING:
      return {
        ...state,
        listTarrifStatus: STATUS.LOADING,
      };
    case OP.LIST_TARRIF_SUCCESS:
      return {
        ...state,
        listTarrifStatus: STATUS.SUCCESS,
        listTarrifResult: payload,
        listTarrifErrorMessage: "",
      };
    case OP.LIST_TARRIF_FAILURE:
      return {
        ...state,
        listTarrifStatus: STATUS.ERROR,
        listTarrifResult: null,
        listTarrifErrorMessage: payload,
      };
    case OP.LIST_TARRIF_RESET:
      return {
        ...state,
        listTarrifStatus: STATUS.DEFAULT,
        listTarrifResult: null,
        listTarrifErrorMessage: "",
      };

    // *-------- > create tarrif reducers
    case OP.CREATE_TARRIF_LOADING:
      return {
        ...state,
        createTarrifStatus: STATUS.LOADING,
      };
    case OP.CREATE_TARRIF_SUCCESS:
      return {
        ...state,
        createTarrifStatus: STATUS.SUCCESS,
        createTarrifResult: payload,
        createTarrifErrorMessage: "",
      };
    case OP.CREATE_TARRIF_FAILURE:
      return {
        ...state,
        createTarrifStatus: STATUS.ERROR,
        createTarrifResult: null,
        createTarrifErrorMessage: payload,
      };
    case OP.CREATE_TARRIF_RESET:
      return {
        ...state,
        createTarrifStatus: STATUS.DEFAULT,
        createTarrifResult: null,
        createTarrifErrorMessage: "",
      };

    // *-------- > update tarrif reducers
    case OP.UPDATE_TARRIF_LOADING:
      return {
        ...state,
        updateTarrifStatus: STATUS.LOADING,
      };
    case OP.UPDATE_TARRIF_SUCCESS:
      return {
        ...state,
        updateTarrifStatus: STATUS.SUCCESS,
        updateTarrifResult: payload,
        updateTarrifErrorMessage: "",
      };
    case OP.UPDATE_TARRIF_FAILURE:
      return {
        ...state,
        updateTarrifStatus: STATUS.ERROR,
        updateTarrifResult: null,
        updateTarrifErrorMessage: payload,
      };
    case OP.UPDATE_TARRIF_RESET:
      return {
        ...state,
        updateTarrifStatus: STATUS.DEFAULT,
        updateTarrifResult: null,
        updateTarrifErrorMessage: "",
      };

    // *-------- > delete tarrif reducers
    case OP.DELETE_TARRIF_LOADING:
      return {
        ...state,
        deleteTarrifStatus: STATUS.LOADING,
      };
    case OP.DELETE_TARRIF_SUCCESS:
      return {
        ...state,
        deleteTarrifStatus: STATUS.SUCCESS,
        deleteTarrifResult: payload,
        deleteTarrifErrorMessage: "",
      };
    case OP.DELETE_TARRIF_FAILURE:
      return {
        ...state,
        deleteTarrifStatus: STATUS.ERROR,
        deleteTarrifResult: null,
        deleteTarrifErrorMessage: payload,
      };
    case OP.DELETE_TARRIF_RESET:
      return {
        ...state,
        deleteTarrifStatus: STATUS.DEFAULT,
        deleteTarrifResult: null,
        deleteTarrifErrorMessage: "",
      };

    default:
      return state;
  }
};
